'use strict';

const API_ROOT = 'https://pippasguardians.jp/wp-json/wp/v2';
const FALLBACK_IMAGE = 'https://pippasguardians.jp/wp-content/themes/pippas/img/noimage.png';

export default class News {
	constructor($element) {
		this.element = $element.get(0);
		this.load();
	}

	async load() {
		try {
			const categoryResponse = await fetch(
				`${API_ROOT}/categories?slug=bbsfj&_fields=id`
			);

			if (!categoryResponse.ok) return;

			const categories = await categoryResponse.json();
			if (!categories.length) return;

			const postsResponse = await fetch(
				`${API_ROOT}/posts?categories=${categories[0].id}&per_page=3&orderby=date&order=desc&_embed`
			);

			if (!postsResponse.ok) return;

			const posts = await postsResponse.json();
			if (!posts.length) return;

			this.render(posts);
		} catch (error) {
			// 通信できない場合は、HTMLに記載された予備のニュースをそのまま表示する。
		}
	}

	render(posts) {
		const fragment = document.createDocumentFragment();

		posts.forEach((post) => {
			fragment.appendChild(this.createCard(post));
		});

		this.element.replaceChildren(fragment);
	}

	createCard(post) {
		const card = document.createElement('article');
		card.className = 'card card--news';

		const imageBox = document.createElement('div');
		imageBox.className = 'image-box image-box--news-thumb';

		const imageLink = this.createLink(post.link);
		const image = document.createElement('img');
		image.className = 'image image--news-thumb';
		image.src = this.getFeaturedImage(post);
		image.alt = this.decodeTitle(post.title.rendered);
		image.loading = 'lazy';
		imageLink.appendChild(image);
		imageBox.appendChild(imageLink);

		const body = document.createElement('div');
		body.className = 'block block--news-body';

		const date = document.createElement('p');
		date.className = 'text text--news-date';
		date.textContent = this.formatDate(post.date);

		const title = document.createElement('h3');
		title.className = 'heading heading--news-title';
		const titleLink = this.createLink(post.link);
		titleLink.classList.add('anchor');
		titleLink.textContent = this.decodeTitle(post.title.rendered);
		title.appendChild(titleLink);

		const readMore = this.createLink(post.link);
		readMore.classList.add('anchor', 'anchor--news-link');
		readMore.textContent = '続きを読む';
		const readMoreTitle = document.createElement('span');
		readMoreTitle.className = 'span span--visually-hidden';
		readMoreTitle.textContent = `：${this.decodeTitle(post.title.rendered)}`;
		readMore.appendChild(readMoreTitle);

		body.append(date, title, readMore);
		card.append(imageBox, body);

		return card;
	}

	createLink(url) {
		const link = document.createElement('a');
		link.href = url;
		link.target = '_blank';
		link.rel = 'noopener noreferrer';
		return link;
	}

	getFeaturedImage(post) {
		const media = post._embedded && post._embedded['wp:featuredmedia'];
		return media && media[0] && media[0].source_url
			? media[0].source_url
			: FALLBACK_IMAGE;
	}

	decodeTitle(html) {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = html;
		return textarea.value;
	}

	formatDate(value) {
		const date = new Date(value);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}.${month}.${day}`;
	}
}
